import React from 'react';
import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';
import FormikTextField from '@ui-lib/components/Inputs/TextField/FormikTextField';
import FormikNumberInput from '@ui-lib/components/Inputs/NumberInput/FormikNumberInput';
import Autocomplete from '@ui-lib/components/Inputs/Autocomplete';
import useCountryOptions from '@web-shared/hooks/useCountryOptions';

import { FIELD_NAMES } from '../const';

interface Props {
  disableRegularFields: boolean;
}

const LocationForm = ({ disableRegularFields }: Props) => {
  const { t } = useTranslation();
  const { countryOptions } = useCountryOptions();
  const countryOptionsLabels = countryOptions.map((option) => option.label);

  const getFieldName = (name: string) => {
    return `${FIELD_NAMES.LOCATION_ADDRESS}.${name}`;
  };

  return (
    <>
      <FormikTextField
        name={FIELD_NAMES.LOCATION_NAME}
        label={t('locationName')}
        required
      />
      <FormikTextField
        name={getFieldName(FIELD_NAMES.ADDRESS)}
        label={t('address')}
        required
        disabled={disableRegularFields}
      />
      <FormikTextField
        name={getFieldName(FIELD_NAMES.CITY)}
        label={t('city')}
        disabled={disableRegularFields}
      />
      <Autocomplete
        name={getFieldName(FIELD_NAMES.COUNTRY)}
        label={t('country')}
        options={countryOptionsLabels}
        isOptionEqualToValue={(option, value) => option === value}
        getOptionLabel={(option) => option}
        filterOptions={(options, state) => options.filter((countryOptionsLabels) => countryOptionsLabels.toLowerCase().startsWith(state.inputValue.toLowerCase()))}
        populateValueToOptions
        withFormik
        disabled={disableRegularFields}
      />
      <FormikTextField
        name={getFieldName(FIELD_NAMES.STATE)}
        label={t('countryState')}
        disabled={disableRegularFields}
      />
      <FormikTextField
        name={getFieldName(FIELD_NAMES.STREET)}
        label={t('street')}
        disabled={disableRegularFields}
      />
      <FormikTextField
        name={getFieldName(FIELD_NAMES.ZIP)}
        label={t('zip')}
        disabled={disableRegularFields}
      />
      <Stack direction='row' spacing={2}>
        <FormikNumberInput
          name={getFieldName(FIELD_NAMES.LATITUDE)}
          label={t('latitude')}
          inputMode='numeric'
          required
          disabled={disableRegularFields}
        />
        <FormikNumberInput
          name={getFieldName(FIELD_NAMES.LONGITUDE)}
          label={t('longitude')}
          inputMode='numeric'
          required
          disabled={disableRegularFields}
        />
      </Stack>
    </>
  );
};
export default LocationForm;
